import React from "react";
import logo from "../assets/company-logo.svg";
import instagramLogo from "../assets/instagram.svg";
import facebookLogo from "../assets/facebook.svg";
import twitterLogo from "../assets/twitter.svg";
import linkedinLogo from "../assets/linkedin.svg";
import gmailLogo from "../assets/gmail.svg";
import { Link, useNavigate } from "react-router-dom";
import { TRACK_STATUS_URL } from "../config/constant";
import { ScrollLink } from "react-scroll";

const Footer = () => {
  const navigate = useNavigate();

  const handleScrollAndNavigate = () => {
    navigate("/about", { state: { scrollTo: "why-gels" } });
  };

  const handleScrollAndNavigateWhatGelDo = () => {
    navigate("/", { state: { scrollTo: "what-gel-do" } });
  };

  return (
    <footer className="">
      <div className="relative w-full h-52 md:h-72 lg:h-80 bg-cover bg-center mb-20 md:mb-32 lg:mb-40 pl-4 md:pl-8 bg-footer-logo-mobile sm:bg-footer-logo">
        {/* Container for the text elements */}
        <div className="absolute top-6 md:top-12 left-6 md:left-12 lg:left-24 flex flex-col space-y-4 md:space-y-6 lg:space-y-8">
          {/* Heading */}
          <h6 className="text-2xl md:text-4xl lg:text-5xl font-bold bg-gradient-to-r from-[#FFFFFF] to-[#004042] text-transparent bg-clip-text">
            Ship Your Dream
          </h6>

          {/* Two Lines of Text */}
          <div className="hidden sm:block text-white mt-3 md:mt-5">
            <p className="text-xs md:text-sm lg:text-md">
              Create a delightful online journey by optimizing
            </p>
            <p className="text-xs md:text-sm lg:text-md">
              your shipping process and everything surrounding it.
            </p>
          </div>

          <div className="sm:hidden text-white mt-3 md:mt-5">
            <p className="text-xs md:text-sm lg:text-md">
              Create a delightful online journey by
            </p>
            <p className="text-xs md:text-sm lg:text-md">
              Optimizing your shipping process and
            </p>
            <p className="text-xs md:text-sm lg:text-md">
              Everything surrounding it.
            </p>
          </div>

          {/* Button */}
          <div className="mt-8 md:mt-8 lg:mt-12">
            <button
              onClick={() => window.open(TRACK_STATUS_URL, "_blank")}
              className="bg-[#FFBD12] text-black text-sm md:text-lg lg:text-xl px-3 py-1 md:px-4 md:py-2 rounded shadow-md"
            >
              Track your order
            </button>
          </div>
        </div>
      </div>
      <div className="hidden md:block">
        <div className="container text-[#7A7272] mx-auto grid grid-cols-1 md:grid-cols-4 gap-4 gap-x-2 mb-8 mx-14">
          {/* Column 1: Logo and Social Media Links */}
          <div className="flex flex-col items-start pr-18">
            <img src={logo} alt="Logo" className="h-24 mb-3 -mt-16 -ml-6" />{" "}
            {/* Adjust the negative margin here */}
            <div className="text-[#031850] pb-4">
              <p className="">A End to End logistics</p>
              <p className="mb-2">& Supply Chain service provider</p>
            </div>
            <div className="flex space-x-7 min-w-[200px]">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={instagramLogo} alt="Instagram" className="h-8 w-8" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={facebookLogo} alt="Facebook" className="h-8 w-8" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={twitterLogo} alt="Twitter" className="h-8 w-8" />
              </a>
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={linkedinLogo} alt="LinkedIn" className="h-8 w-8" />
              </a>
              <a
                href="mailto:your-email@example.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={gmailLogo} alt="Gmail" className="h-8 w-8" />
              </a>
            </div>
          </div>

          {/* Column 2: Four Small Text Links */}
          <div className="flex flex-col items-start -pr-4 md:pr-0">
            <ul className="space-y-2">
              <li>
                <div>
                <button
                  onClick={handleScrollAndNavigate}
                  className="hover:text-gray-400"
                >
                  Why GELS?
                </button>
                </div>
              </li>
              <li>
              <button
                onClick={handleScrollAndNavigateWhatGelDo}
                className="hover:text-gray-400"
              >
                What GELS Do
              </button>
              </li>
              <li>
                <Link to="/services" className="hover:text-gray-400">
                  GELS Strength
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-gray-400">
                  GELS Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: About, Contact, Services Links */}
          <div className="flex flex-col pr-4 md:pr-0">
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="hover:text-gray-400">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-gray-400">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-gray-400">
                  Services
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Normal Text */}
          <div className="flex flex-col">
            <ul className="space-y-2">
              <li>Global Exim and Logistics Solutions</li>
              <li>+91 98453 85842</li>
              <li>globaleximblr@gmail.com</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="md:hidden">
        <div className="container mx-auto px-4 py-4 text-[#7A7272]">
          {/* Row 1: Logo and Contact Info in Two Columns */}
          <div className="flex justify-between items-end">
            {/* Logo and Tagline */}
            <div className="flex flex-col items-start">
              <img src={logo} alt="Logo" className="h-20 -mt-16 -ml-6 mb-4" />
              <p className="text-[#031850] text-sm">A End to End logistics</p>
              <p className="text-[#031850] text-sm">
                & Supply Chain service provider
              </p>
            </div>
            {/* Contact Information */}
            <div className="text-[#7A7272] text-sm text-left">
              <p>Global Exim and Logistics Solutions</p>
              <p>+91 98453 85842</p>
              <p>globaleximblr@gmail.com</p>
            </div>
          </div>

          {/* Row 2: Links and About Section in Horizontal Layout */}
          <div className="flex items-start mt-6  space-x-20">
            {/* Links Column */}
            <div className="flex flex-col items-start space-y-1">
              <button
                onClick={handleScrollAndNavigate}
                className="hover:text-gray-400"
              >
                Why GELS?
              </button>
              <button
                onClick={handleScrollAndNavigateWhatGelDo}
                className="hover:text-gray-400"
              >
                What GELS Do
              </button>
              <a href="/services" className="hover:text-gray-400">
                GELS Strength
              </a>
              <a href="/services" className="hover:text-gray-400">
                GELS Services
              </a>
            </div>

            {/* About, Contact, Services Column */}
            <div className="flex flex-col space-y-1">
              <Link to="/about" className="hover:text-gray-400">
                About
              </Link>
              <Link to="/contact" className="hover:text-gray-400">
                Contact
              </Link>
              <Link to="/services" className="hover:text-gray-400">
                Services
              </Link>
            </div>
          </div>

          {/* Row 3: Social Media Icons */}
          <div className="flex justify-around mt-6">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagramLogo} alt="Instagram" className="h-10 w-10" />
            </a>
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebookLogo} alt="Facebook" className="h-10 w-10" />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={twitterLogo} alt="Twitter" className="h-10 w-10" />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedinLogo} alt="LinkedIn" className="h-10 w-10" />
            </a>
            <a
              href="mailto:your-email@example.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={gmailLogo} alt="Gmail" className="h-10 w-10" />
            </a>
          </div>
        </div>
      </div>
      <div className="bg-[#0300AF] text-white text-center p-4 text-xs sm:text-sm md:text-lg">
        <p>Copyrights @ Global Exim and Logistics Solutions</p>
      </div>
    </footer>
  );
};

export default Footer;
